import { useState, FC, FormEvent } from "react";
import DaneaLogo from "assets/daneaimport-logo-title.png";
import { LoginFormProps } from "./type";
import style from "./style.module.scss";

export const LoginForm: FC<LoginFormProps> = (props) => {
  const { title, inputPlaceholder, inputType, initialInputValue = "" } = props;

  const [inputValue, setInputValue] = useState(initialInputValue);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    props.submitAction(inputValue);
  };

  return (
    <div
      className={`d-flex flex-column align-items-center mx-auto gap-4 ${style.container}`}
    >
      <div className="logo-box mx-5">
        <img src={DaneaLogo} alt="Logo" className="img-fluid" />
      </div>
      <div
        className={`login-box rounded-1 p-4 w-100 ${style["form-container"]}`}
      >
        <form className="row flex-column gap-4 my-2" onSubmit={handleSubmit}>
          <h5 className="col text-primary text-center">{title}</h5>
          <div className="col form-group">
            <input
              type={inputType}
              className="form-control"
              placeholder={inputPlaceholder}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              required
            />
          </div>
          <div className="col">
            <button
              type="submit"
              className="btn btn-secondary submit-btn text-white w-100"
            >
              ACCEDI
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
